export const PHOTO_GALLERY_OPTIONS = [
  "id",
  "title",
  "createdAt",
  "description",
];
